import Application from "../../Application";
import Area, { IArea } from "./Area";
import { IRouter } from "../../runtime/Router";
import { Layouts } from "../common/Constants";
import ShowHomeInteractor from "../interactor/main/ShowHomeInteractor";
import { ITranslationService } from "../service/locale/TranslationService";
import ContentNotFoundPage from "../ui/pages/ContentNotFoundPage";
import ForbiddenPage from "../ui/pages/ForbiddenPage";
import HomePage from "../ui/pages/main/HomePage";

export default class HomeArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;
  private translationService: ITranslationService;

  constructor({
    application,
    translationService,
    router
  }: {
    application: Application;
    router: IRouter;
    translationService: ITranslationService;
  }) {
    super();
    this.application = application;
    this.router = router;
    this.translationService = translationService;
  }

  register(params: any) {
    this.router.registerRoutes({
      path: "/error",
      page: this.createPage({
        Page: ContentNotFoundPage,
        action: this.showHomePage.bind(this)
      }),
      options: {
        secure: false,
        initialProps: {
          title: "errors.not_found_error_title",
          text: "errors.not_found",
          buttonLabel: "errors.error_recovery_action",
          router: this.router,
          translate: this.translationService.get
        },
        layout: Layouts.BASE
      }
    });
    this.router.registerRoutes({
      path: "/",
      page: this.createPage({
        Page: HomePage,
        action: this.showHomePage.bind(this)
      }),
      options: {
        secure: true
      }
    });

    this.router.registerRoutes({
      path: "/forbidden",
      page: this.createPage({
        Page: ForbiddenPage,
        action: () => {}
      }),
      options: {
        secure: false,
        initialProps: {
          title: "errors.forbidden_error_title",
          text: "errors.forbidden",
          buttonLabel: "errors.error_recovery_action",
          router: this.router,
          translate: this.translationService.get
        },
        layout: Layouts.BASE
      }
    });
  }

  public showHomePage() {
    return this.application.container
      .resolve<ShowHomeInteractor>("showHome")
      .execute();
  }
}
